export default __webpack_public_path__ + "static/media/heap.0b65fb30.png";